import { Link } from "@tanstack/react-router";
import { useState } from "react";
import {
  ChevronsLeftIcon,
  HomeIcon,
  UserIcon,
  MessageCirclePlusIcon,
  SearchCheckIcon,
  NotebookText,
  Building2Icon,
} from "lucide-react";

export function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav
      className="sticky top-0 flex h-screen shrink-0 flex-col items-start justify-between bg-[#033154] p-4 text-foreground"
      style={{
        width: isOpen ? "16rem" : "5rem",
      }}
    >
      <div className="flex w-full flex-col items-center justify-center gap-1">
        <Link to={"/dashboard"} className="pb-4">
          <Logo isOpen={isOpen} />
        </Link>
        <SidebarItem
          Icon={HomeIcon}
          text="Dashboard"
          link="/dashboard"
          sidebarIsOpen={isOpen}
          exactMatch
        />
        <SidebarItem
          Icon={MessageCirclePlusIcon}
          text="Question Generation"
          link="/dashboard/quiz/new/select-subject"
          sidebarIsOpen={isOpen}
        />
        <SidebarItem
          Icon={SearchCheckIcon}
          text="Evaluations"
          link="/dashboard/evaluate/new"
          sidebarIsOpen={isOpen}
        />
        <SidebarItem
          Icon={NotebookText}
          text="Course Material"
          link="/dashboard/presentation"
          sidebarIsOpen={isOpen}
        />
        <SidebarItem
          Icon={UserIcon}
          text="My Profile"
          link="/dashboard/profile"
          sidebarIsOpen={isOpen}
        />
        <SidebarItem
          Icon={Building2Icon}
          text="My Organization"
          link="/dashboard/organization"
          sidebarIsOpen={isOpen}
        />
      </div>
      <button
        className={`flex w-full items-center gap-2 ${!isOpen && "justify-center"}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <ChevronsLeftIcon className={`size-6 ${!isOpen && "rotate-180"}`} />
        {isOpen && <span>Close Sidebar</span>}
      </button>
    </nav>
  );
}

function Logo({ isOpen }: { isOpen: boolean }) {
  return (
    <div className="flex w-full items-center justify-center gap-2 text-3xl font-bold">
      {isOpen && (
        <div className="flex gap-2">
          <span>E</span>
          <span>D</span>
          <span>U</span>
        </div>
      )}
      <img src="/logo.svg" alt="logo" className="size-8 cursor-pointer" />
      {isOpen && (
        <div className="flex gap-2">
          <span>O</span>
          <span>V</span>
          <span>A</span>
        </div>
      )}
    </div>
  );
}

function SidebarItem({
  Icon,
  text,
  link,
  sidebarIsOpen,
  exactMatch,
}: {
  Icon: React.ElementType;
  text: string;
  link: string;
  sidebarIsOpen: boolean;
  exactMatch?: boolean;
}) {
  return (
    <Link to={link} activeOptions={{ exact: exactMatch }} className="w-full">
      {({ isActive }) => (
        <div
          className={`flex w-full flex-row items-center gap-2 rounded-xl p-2 ${
            isActive ? "bg-[#043f6c]" : "bg-transparent"
          } ${!sidebarIsOpen && "justify-center"}`}
        >
          <Icon className={sidebarIsOpen ? "size-4" : "size-5"} />
          {sidebarIsOpen && <span>{text}</span>}
        </div>
      )}
    </Link>
  );
}
